import { useSelector } from 'react-redux';
import { useGetMe } from './hooks/useUser';
import Auth from './components/compound/Auth';
import LoadingPage from './components/common/LoadingPage';
import View from './View';
import { useReloadOnNewRelease } from './lib/appVersion';

function App() {
  // Open tabs pick up a new release on their next page change.
  useReloadOnNewRelease();
  const { status } = useGetMe();
  const { user } = useSelector((state) => state.auth);

  if (!user) {
    if (status === 'loading' || status === 'idle') {
      return <LoadingPage />;
    }
    return <Auth />;
  }

  return <View />;
}

export default App;
